import type { ReactNode } from 'react';
import { Card, CardContent } from '@/components/ui/card';

interface AuthLayoutProps {
  children: ReactNode;
  title?: string;
}

export function AuthLayout({ children, title }: AuthLayoutProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-white relative">
      {/* Dot grid background */}
      <div 
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage: 'radial-gradient(circle, #d1d5db 1px, transparent 1px)',
          backgroundSize: '24px 24px',
        }}
      />
      
      <div className="relative z-10 w-full max-w-md px-4 py-8">
        {/* Logo */}
        <div className="text-center mb-8">
          <img 
            src="/images/doploy-logo.png" 
            alt="doploy" 
            className="h-8 mx-auto"
          />
        </div>
        
        {/* Main Card */}
        <Card className="shadow-lg border border-gray-200">
          <CardContent className="p-8">
            {title && (
              <h1 className="text-xl font-semibold text-gray-900 mb-6">{title}</h1>
            )}
            {children}
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
